import Filter from "../Filter/Filter"

// flex justify-between items-center w-4/5 max-w-md max-h-32 h-24 bg-white absolute top-32 left-2/4 transform -translate-x-2/4 rounded-md py-5 px-4 shadow-lg 

const FiltersContainer = ({ filters, onClearFiltersClick, removeFilterHandler }) => {

  if (filters.length === 0) {
    return (
      <div className="opacity-0 mt-14 w-4/5 max-w-md max-h-32 h-24">

      </div>
    )
  }

  return (
    <header className="flex justify-between items-center w-4/5 max-w-md bg-white rounded-md py-5 px-4 shadow-lg mt-32 relative z-10 xl:max-w-5xl xl:px-10 xl:py-4">
      <div className="flex flex-wrap w-full">
        {/* Filters */}
        {
          filters.map(filter => (
            <div className="mr-3 mb-1.5 mt-1.5" key={filter}>
              <Filter
                name={filter}
                withDelete={true}
                removeFilterHandler={removeFilterHandler}
              />
            </div>
          ))
        }
        {/* <Filter
          name='Frontend'
          withDelete={true}
        /> */}
      </div>
      {/* Clear */}
      <p className="font-semibold text-cyan-dark-grayish text-xs cursor-pointer hover:underline hover:text-cyan-desaturated-dark xl:text-sm" onClick={onClearFiltersClick}>
        Clear
      </p>
    </header>
  );
};

export default FiltersContainer;